export default {
  projectFilterLabel: 'Projects',
  export: 'Export',
  title: 'Detailed Practice Group Report',
};
